import { FileArchive, FileCode, FileText, FileType } from 'lucide-react';

/** Get file type icon based on extension */
export const getFileIcon = (filename: string, size = 16) => {
  const ext = filename.split('.').pop()?.toLowerCase();
  switch (ext) {
    case 'pdf':
      return <FileType size={size} className="text-accent-red" />;
    case 'doc':
    case 'docx':
      return <FileText size={size} className="text-accent-blue" />;
    case 'txt':
    case 'md':
    case 'xml':
      return <FileCode size={size} className="text-text-tertiary" />;
    case 'zip':
      return <FileArchive size={size} className="text-accent-amber" />;
    default:
      return <FileText size={size} className="text-text-tertiary" />;
  }
};
